
<template>
    <div class="videoWrap">
        <!--
        阿里
            加密
            http://test-video-file.oss-cn-shenzhen.aliyuncs.com/class/make/video/Ys-mask-video/f1517a5e43a14428a3323f293d85ab07/1607414887929
            普通source
            http://test-video-file.oss-cn-shenzhen.aliyuncs.com/class/study/video/Ys-st-video/04d02dae95f34ec5bb745ad1e6c34e02/QQ录屏20200520155353.mp4

        天翼云
            http://file.gzedu.com/upload/downloadFile.do?uploadInfoId=98d359ae88c34acf956bdf6a3e3a9c4d
        -->
        <div v-if="showAli" class="prism-player" id="J_prismPlaye" style="width: 100%;height: 100%;"></div>
        <video autoplay controls controlslist="nodownload" v-if="showTianyi" :src="filegzeduVideoUrl" style="width: 100%;height: 100%;"></video>
    </div>
</template>
<script>
import EPlayer from '../../components/ePlayer.js';

export default {
    data() {
        return {
            player: '',
            filegzeduVideoUrl: '',
            showAli: false,
            showTianyi: false,
            videoFormat: 'mp4',
        };
    },
    components:{

    },
    watch:{

    },
    mounted(){
        let urlQuery = this.appUtils.getUrlQuery('url');
        urlQuery = decodeURIComponent(urlQuery);
        let urlMediaId = this.appUtils.getUrlQuery('mid') || this.appUtils.getUrlQuery('mediaId');
        let format = this.appUtils.getUrlQuery('format')
        if (format) {
            this.videoFormat = format
        } else {
          if (urlQuery.includes('Ys-st-video') || urlQuery.includes('study') || urlQuery.includes('act-video-material')){
            this.videoFormat = 'mp4';
          } else {
            this.videoFormat = 'm3u8';
          }
        }
        if (urlMediaId){
            this.showAli = true;
            this.getPlayerParamByMediaId(urlMediaId);
        } else {
            this.analyseUrl(urlQuery);
        }

    },
    methods: {
        initVideo(url){
            this.player = new EPlayer("J_prismPlaye", { source: url, autoplay: true });
            this.player.initVideo();
        },
        analyseUrl(url){
            if (url.includes('aliyuncs')){
                url.replace('vcg-yjyp-resource', 'cdn-res.ttcn.cn');
                url.replace('yjyp-tt-video-file.oss-cn-shenzhen.aliyuncs.com', 'v.ttcn.cn');
                url.replace('yjyp-ttfile1.oss-cn-shenzhen.aliyuncs.com','eefile.download.ttcn.cn');
                // 阿里云
                this.getVideoByOssUrl(url);
                this.showAli = true;
            } else if (url.includes('file.gzedu.com')){
                // 天翼云
                this.fileGzeduVideo(url);
            } else {
                // 其他地方一律用h5播放
                this.setVideoUrl(url);
            }
        },
        getVideoByOssUrl(url){
            this.axios.get(this.appUtils.getSignWithUrl(this.apis.video.getMediaIdByOssUrl + '?ossUrl=' + url))
            .then((res)=>{
                console.log(res);
                if (res.data.data.MediaId && res.data.data.PublishState != 'Published' && res.data.data.RunIdList.RunId[0]){
                    // 有 mediaId ，加密播放，并且状态不是Published，就查RunId
                    this.getMediaWorkflowExecutionByRunId(res.data.data.MediaId, res.data.data.RunIdList.RunId[0]);
                } else if(res.data.data.MediaId && res.data.data.PublishState == 'Published'){
                    // 有 mediaId ，并且状态是Published，直接用mediaId
                    this.getPlayerParamByMediaId(res.data.data.MediaId);
                } else if (!res.data.data.MediaId){
                    // 没有 mediaId ，普通source播放，这里逻辑修改了，如果没有时候，再找下有没有历史记录的转码后的地址. 2022-08-28
                    this.axios.get(this.appUtils.getSignWithUrl(this.apis.video.getMappingSdPathUrl + '?ossUrl=' + url)).then((sdres) => {
                        if(sdres.data.data.ossSdPath) {
                            console.log('历史转码路径为', sdres.data.data.ossSdPath)
                            this.initVideo(sdres.data.data.ossSdPath);
                        } else {
                            this.initVideo(url);
                        }
                    })
                }
            }).catch((err)=> {
                console.log(err);
                 this.initVideo(url);
            });
        },
        initAliPlayer(vid, accId, accSecret, stsToken, domainRegion, authInfo, format, seek){
            this.playerShow = true;
            this.$nextTick(function () {
                this.player = new EPlayer("J_prismPlaye", {
                    vid, accId, accSecret, stsToken, domainRegion, authInfo, format, seek:seek||0, format: this.videoFormat, autoplay: true
                });
                this.player.initVideo();

            });
        },
        getPlayerParamByMediaId(mediaId){
            this.axios.get(this.appUtils.getSignWithUrl(this.apis.video.getPlayerParamByMediaId + '/' + mediaId))
                .then(res => {
                    console.log(res);
                    let resData = res.data;
                    if (resData.data.vid) {
                        this.playerShow = false;
                        this.$nextTick(function () {
                            this.initAliPlayer(resData.data.vid, resData.data.accId,
                                resData.data.accSecret, resData.data.stsToken, resData.data
                                .domainRegion, resData.data.authInfo, resData.data.format,
                                0);
                        });
                    }
                }).catch(err => {
                    this.$message.error('获取媒体id失败');
                })
        },
        getMediaWorkflowExecutionByRunId (mediaId, runId){
            let ThisrunId = runId;
            // this.runId = res.data.RunIdList.RunId[0];
            // console.log(this.runId);
            this.axios.get(this.appUtils.getSignWithUrl(this.apis.video.getMediaWorkflowExecutionByRunId + '/' + ThisrunId)).then(res => {
                console.log(res);
                // this.runId = res.data.RunIdList.RunId[0];
                if (res.data.data.State == 'Running') {
                    let that = this;
                    let time = setTimeout(function () {
                        that.getMediaWorkflowExecutionByRunId(mediaId, ThisrunId);
                    }, 5000)
                } else if (res.data.data.State == 'Completed') {
                    this.$nextTick(function () {
                        this.axios.get(this.appUtils.getSignWithUrl(this.apis.video.getPlayerParamByMediaId + '/' + res.data.data.MediaId))
                            .then(res => {
                                console.log(res);
                                let resData = res.data;
                                if (resData.data.vid) {
                                    this.playerShow = false;
                                    this.$nextTick(function () {
                                        this.initAliPlayer(resData.data.vid, resData.data.accId,
                                            resData.data.accSecret, resData.data.stsToken, resData.data
                                            .domainRegion, resData.data.authInfo, resData.data.format,
                                            0);
                                    });
                                }
                            }).catch(err => {
                                this.$message.error('获取媒体id失败');
                            })
                    });
                }
            }).catch(err => {
                console.log(err);
            })

        },
        fileGzeduVideo (url){
            // http://file.gzedu.com/apiUpload/shareUrl.do?uploadInfoId=7dd8c6d62db94d179dc5f0cc9ee0032c

            this.axios.get(this.apis.video.fileGzeduUpload + '?uploadInfoId=' + this.appUtils.getTextQuery(url, 'uploadInfoId'))
            .then(res => {
                console.log(res);
                if (res.data.shareUrl){
                    this.setVideoUrl(res.data.shareUrl);
                    this.$nextTick(function () {
                    });
                }
            }).catch(err => {
                console.log(err);
            })

        },
        setVideoUrl (url){
            this.filegzeduVideoUrl = url;
            this.showTianyi = true;
        }
    }
};
</script>
<style>
    .videoWrap{
        height: 100%;
        width: 100%;
        overflow: hidden;
    }
</style>
